(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.rollInGraph = {
    attach: (context) => {
      Drupal.behaviors.rollInGraph.normalizeLabels();
      window.addEventListener('resize', Drupal.debounce(Drupal.behaviors.rollInGraph.normalizeLabels, 250, false));

      if (!$('.roll-in-graph', context).length) {
        return;
      }

      // Do not do any animation if person has prefers-reduced-motion set.
      var mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      if (!mediaQuery || mediaQuery.matches) {
        $('.roll-in-graph', context).removeClass('roll-in-graph');
        return;
      }

      Array.from(document.getElementsByClassName('roll-in-graph-values')).forEach(graphWrapper => {
        // Start animating when the element is 20% in view.
        let visibilityTrigger = function (entries, observer) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              observer.unobserve(graphWrapper);
              $(graphWrapper).find('.graph-value-bar').each(function (index, element) {
                window.setTimeout(function () {
                  $(element).addClass('animated');
                }, index * 300);
              });
            }
          });
        };
        let observerOptions = { threshold: 0.2 };
        let observer = new IntersectionObserver(visibilityTrigger, observerOptions);
        observer.observe(graphWrapper);
      });
    },

    normalizeLabels: () => {
      // Normalize the widths of the text labels so that our bar
      // widths remain consistent with the data.
      $('.brick--graph').each(function (i, graph) {
        let maxRowWidth = 0;
        let longestRow;
        let minimumLabelWidth = $(graph).width() / 6;
        $('.graph-value-text', graph).css('width', '');
        $('.graph-value', graph).each(function (j, valueRow) {
          let fullWidth = $(valueRow).width();
          if (fullWidth > maxRowWidth) {
            maxRowWidth = fullWidth;
            longestRow = valueRow;
          }
        });
        let longestRowLabelWidth = $('.graph-value-text', longestRow).width();
        $('.graph-value-text', graph).css('width', Math.max(minimumLabelWidth, longestRowLabelWidth));
      });
    }
  };

})(jQuery, Drupal);
